// The notice after a tune is filed into a playlist (Oct 2026), ONE for every
// way of filing: the tune header's Add to playlist, the phone's Tune menu and
// Playlists menu, a home card, the mini player. It used to be four — a
// 2-second "✓ Added to X" from the header with no way on, a 6-second home
// notice with Undo from a card — and none could take you to the playlist,
// which is the first thing you want after filing (the playlist review: "did
// it go where I meant, and can I see it?"). One notice, with Open and Undo,
// drawn by PlaylistAddedToast wherever you are. Not a component, so the panel
// that files the tune and the toast share it without a provider
// (react-refresh wants component files to export only components).

import { useSyncExternalStore } from 'react';

export interface PlaylistAddedNotice {
  id: number;
  playlistId: string;
  playlistName: string;
  /** The row the add made, for Undo. */
  entryId: string | null;
}

let current: PlaylistAddedNotice | null = null;
let nextId = 1;
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

/** Say a tune was filed; a new notice replaces the last. */
export function showPlaylistAdded(notice: Omit<PlaylistAddedNotice, 'id'>): void {
  current = { id: nextId++, ...notice };
  emit();
}

/** Take the notice down; with an id, only if it is still the one showing. */
export function dismissPlaylistAdded(id?: number): void {
  if (!current || (id !== undefined && current.id !== id)) return;
  current = null;
  emit();
}

export function usePlaylistAdded(): PlaylistAddedNotice | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
    () => null,
  );
}
